<script>
    import { onMount, createEventDispatcher } from "svelte";
    import WeatherNight from "svelte-material-icons/WeatherNight.svelte";
    import WeatherSunny from "svelte-material-icons/WeatherSunny.svelte";
    import Resize from "svelte-material-icons/Resize.svelte";
    import BugOutline from "svelte-material-icons/BugOutline.svelte";
    import {
        isAuthenticated,
        hostname,
        username,
        environment,
        version,
        site,
        stack,
        stacks,
        theme,
        accessInfo,
        isAuthorised,
        showDebug
    } from "../stores.js";
    import { canvasSize } from "../previewstores.js";
    import Download from "svelte-material-icons/Download.svelte";
    import { initAuthClient, login, logout } from "../auth.js";
    import { downloader, showDownloader, downloadJobs } from "../downloadstores.js";
    // import Gravatar from 'svelte-gravatar'; // Commented out until needed
    import { toast } from "@zerodevx/svelte-toast";
    import {
        toastThemeError,
        toastThemeSuccess,
        toastThemeErrorDismissable,
        toastThemeSuccessDismissable,
    } from "../toasts.js";
    import {
        now,
        isNumeric,
        getStackDisplayName,
        getAccessInfoApi,
        testAuth0Api
    } from "../utils.js";
    import { push } from "svelte-spa-router";
    import { tooltip } from "svooltip";
    import 'svooltip/styles.css';

    /**
     * Event handling
     */
    const dispatch = createEventDispatcher();

    // We assume here that we have loaded the $stack from the store before this initialisation.
    let optionStacks;
    let selectedStackId; // The object being updated by the select component

    $: {
        if ($isAuthenticated) {
            if (!$accessInfo) {
                console.log("FETCHING ACCESS INFO BECAUSE AUTHENTICATED AND STACKS= ", stacks);
                //testAuthorisation();
                getAccessInformation();
                console.log("DONE ACCESS INFO FETCHING. STACKS= ", stacks);

                initStackSelector();
            }
        }
    }

    let authorisationPolicyOrganisation;
    let authorisationRequestedForDataset;
    let authorisationPolicyReason;
    // eslint-disable-next-line no-unused-vars
    async function testAuthorisation() {
        if ($isAuthenticated) {
            const testAuthClientResponse = await testAuth0Api($hostname);
            console.log("HEADER AUTH TEST: ", testAuthClientResponse);
            if (testAuthClientResponse?.isAuthorised) {
                $isAuthorised = true;
            } else {
                $isAuthorised = false;
            }

            if (testAuthClientResponse?.organization) {
                authorisationPolicyOrganisation = testAuthClientResponse.organization;
            } else {
                authorisationPolicyOrganisation = undefined;
            }

            if (testAuthClientResponse?.dataset) {
                authorisationRequestedForDataset = testAuthClientResponse.dataset;
            } else {
                authorisationRequestedForDataset = undefined;
            }

            if (testAuthClientResponse?.reason) {
                authorisationPolicyReason = testAuthClientResponse.reason;
            } else {
                authorisationPolicyReason = undefined;
            }

            if ($isAuthorised == false) {
                if (isNumeric(testAuthClientResponse)) {
                    let errorMsg;
                    switch (testAuthClientResponse) {
                        case 401:
                            errorMsg = "Not logged in";
                            break;
                        case 503:
                            errorMsg = "Service unavailable";
                            break;
                        default:
                            errorMsg = testAuthClientResponse;
                    }
                    let msg = `${now()}<br/>Test auth API error: ${errorMsg}`;
                    toast.push(msg, toastThemeError);
                } else {
                    let msg = `${now()}<br/>Authorisation error: ${authorisationPolicyReason}`;
                    toast.push(msg, toastThemeErrorDismissable);
                    console.log('TEST AUTH POLICY ORGANISATION:', authorisationPolicyOrganisation);
                    console.log('TEST AUTH REQUESTED FOR DATASET:', authorisationRequestedForDataset);
                    console.log('TEST AUTH POLICY REASON:', authorisationPolicyReason);
                }
            }
        }
    }

    async function getAccessInformation() {
        if ($isAuthenticated) {
            const getAccessInfoApiResponse = await getAccessInfoApi($hostname);
            if (isNumeric(getAccessInfoApiResponse)) {
                let errorMsg;
                switch (getAccessInfoApiResponse) {
                    case 401:
                        errorMsg = "Not logged in";
                        break;
                    case 503:
                        errorMsg = "Service unavailable";
                        break;
                    default:
                        errorMsg = getAccessInfoApiResponse;
                }
                let msg = `${now()}<br/>Get access info API error: ${errorMsg}`;
                toast.push(msg, toastThemeError);
            } else {
                console.log("ACCESS INFO: ", getAccessInfoApiResponse);
                let orgTeams = getAccessInfoApiResponse?.userservice_org_teams
                    ?.map((o) => {
                        let orgLabel = o.teams.map((t) => {
                            const name = t.name || t;
                            return `${o.name}:${name}`;
                        })?.join(", ");
                        if (o.role == 'admin') {
                            orgLabel = `ADMIN:` + orgLabel;
                        }
                        return orgLabel;
                    })
                    .join("; ");
                console.log("ACCESS INFOR GOT THESE TEAMS: ", orgTeams);
                let msg = `${now()}<br/>Access info: User ${getAccessInfoApiResponse?.userservice_name} ${
                    orgTeams ? "(" + orgTeams + ")" : ""
                } has access to cluster(s) ${getAccessInfoApiResponse?.stacks
                    ?.map((s) => getStackDisplayName(s))
                    ?.join(", ")}`;
                toast.push(msg, toastThemeSuccessDismissable);

                /* DEBUG:
                let msg1 = `${now()}<br/>Access info: User Service says user identified as ${getAccessInfoApiResponse?.userservice_name}`;
                toast.push(msg1, toastThemeSuccessDismissable);
                let msg2 = `${now()}<br/>Access info: User Service says user has access to clusters ${getAccessInfoApiResponse?.userservice_stacks?.join(', ')}`;
                toast.push(msg2, toastThemeSuccessDismissable);
                let msg3 = `${now()}<br/>Access info: User Service says user belongs to teams ${getAccessInfoApiResponse?.userservice_org_teams?.map(o => {return o.teams.map(t => `${o.name}:${t}`)}).join(', ')}`;
                toast.push(msg3, toastThemeSuccessDismissable);
                */

                $accessInfo = getAccessInfoApiResponse;

                console.log("HEADER SEES STACKS:", stacks);
                console.log("HEADER SEES ACCESSINFO STACKS:", $accessInfo?.stacks);
                console.log("HEADER SEES ACCESSINFO STACKS LENGTH:", $accessInfo?.stacks?.length);
                console.log("HEADER SEES ACCESSINFO ORG_TEAMS:", $accessInfo?.userservice_org_teams);

                if ($accessInfo?.stacks?.length > 0) {
                    optionStacks = stacks?.map((s, i) => {
                        return { id: i + 1, name: s };
                    });
                    // Make sure the selector defaults to currently stored setting
                    if ($stack) {
                        console.log("HEADER SEES STACK:", $stack);
                        const selectedStack = optionStacks?.find((s) => {
                            return s.name == $stack;
                        });
                        selectedStackId = selectedStack?.id;
                        console.log("selectedStackId=", selectedStackId);
                    }
                    console.log("SETTING ISAUTHORISED TO true");
                    $isAuthorised = true;
                    console.log("ISAUTHORISED IS NOW ", $isAuthorised);
                } else {
                    console.log("SETTING ISAUTHORISED TO false");
                    $isAuthorised = false;
                    console.log("ISAUTHORISED IS NOW ", $isAuthorised);
                }
            }
        }
    }

    // This function is never executed but it being there changes the behavior of the program
    // eslint-disable-next-line no-unused-vars
    function updateSelector() {
        /* eslint no-undef: off */
        value = 1;
    }

    async function onLogin(options) {
        await login(options);
    }

    async function onLogout() {
        logout();
    }

    async function admin() {
        push('/admin');
    }

    const LIGHT = "light";
    const DARK = "dark";
    function toggleDarkTheme() {
        if ($theme === LIGHT) {
            $theme = DARK;
            window.document.body.classList.toggle("dark");
        } else {
            $theme = LIGHT;
            window.document.body.classList.toggle("dark");
        }
    }

    function toggleCanvasSize() {
        if ($canvasSize == 768) {
            $canvasSize = 1024;
            const msg = `Large image mode set`;
            toast.push(msg, toastThemeSuccess);
        } else if ($canvasSize == 1024) {
            $canvasSize = 768;
            const msg = `Small image mode set`;
            toast.push(msg, toastThemeSuccess);
        }
    }

    function toggleDownloader() {
        if (!$downloader) return;
        if ($showDownloader) $showDownloader = false;
        else $showDownloader = true;
    }

    function toggleDebug() {
        $showDebug = !$showDebug;
    }

    function onChangedStack() {
        // Update the stack value
        // We use id Number for the select component because it does an === match internally.
        console.log("SELECTEDSTACKID=", selectedStackId);
        console.log("OPTIONSTACKS=", optionStacks);
        let selectedStack = optionStacks?.find((s) => s.id === selectedStackId);
        if (selectedStack) {
            $stack = selectedStack?.name;
        }

        // Notify listerners that we have changed stack
        dispatch("change", $stack);
    }

    function initStackSelector() {
        if ($isAuthorised) {
            console.log("UPDATING OPTIONSTACKS BECAUSE AUTHORISED", stacks);
            // If we have stacks, we update the options to be shown in the stack selector.
            // The selector works with Number ids, not strings, so we can't just give it a list of strings.
            // That's why we create {id, name} objects here.
            optionStacks = stacks?.map((s, i) => {
                return { id: i + 1, name: s };
            });

            // Make sure the selector defaults to currently stored setting
            if ($stack) {
                console.log("HEADER SEES STACK:", $stack);
                const selectedStack = optionStacks?.find((s) => {
                    return s.name == $stack;
                });
                selectedStackId = selectedStack?.id;
                console.log("selectedStackId=", selectedStackId);
            }
        }
    }

    onMount(async () => {
        await initAuthClient($environment);
        initStackSelector();
    });
</script>

<header-pane>
    {#if $isAuthenticated && $isAuthorised && optionStacks}
        <header-stack-selector>
            <select bind:value={selectedStackId} on:change={onChangedStack}>
                {#each optionStacks as stackOption}
                    <option value={stackOption.id}>
                        {getStackDisplayName(stackOption.name)}
                    </option>
                {/each}
            </select>
        </header-stack-selector>
    {/if}
    <header-text class={$environment}>Exciscope Processing UI</header-text>
    <!--logo-container/-->
    <header-user style="color: {$isAuthorised ? 'currentColor' : 'grey'}">{$username ? $username : ""}</header-user>
    <!-- TODO: Use MD5 hash instead of sending email to server -->
    <!--{#if $email}<Gravatar email={$email} alt="Profile image" size={36}/>{/if}-->
    {#if $accessInfo?.userservice_org_teams?.some(o => o.role == "admin")}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <header-admin-button on:click={admin} style="display:{$isAuthenticated  ? 'block' : 'none'};">
            Admin
        </header-admin-button>
    {/if}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <header-login-button on:click={onLogin} style="display:{$isAuthenticated ? 'none' : 'block'};">
        Login
    </header-login-button>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <header-logout-button on:click={onLogout} style="display:{$isAuthenticated ? 'block' : 'none'};">
        Logout
    </header-logout-button>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <header-downloader-toggle-button class:disabled={$downloadJobs?.length <= 0} on:click={toggleDownloader}>
        <Download color="currentColor" size="1.5em" />
    </header-downloader-toggle-button>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <header-dark-toggle-button on:click={toggleDarkTheme}>
        {#if $theme == LIGHT}
            <WeatherNight color="currentColor" size="1.5em" />
        {:else}
            <WeatherSunny color="currentColor" size="1.5em" />
        {/if}
    </header-dark-toggle-button>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <header-canvas-size-button on:click={toggleCanvasSize} use:tooltip={{content: "Toggle size of image canvas", placement: "bottom-start", delay: [1000, 0]}}>
        <Resize color="currentColor" size="1.5em" />
    </header-canvas-size-button>
    {#if window.location.search.includes("debug=true")}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <header-debug-button class:disabled={!$showDebug} on:click|preventDefault|stopPropagation={toggleDebug}>
            <BugOutline color="currentColor" size="1.5em" />
        </header-debug-button>
    {/if}
</header-pane>
<header-version>{$site} {$version}</header-version>

<style>
    header-stack-selector {
        /* position: fixed; */
        left: 0;
        /*border: 1px solid blue;*/
        padding-top: 3px;
        flex-grow: 0;
    }
    header-stack-selector > select {
        border: none;
        background-color: transparent;
        /*color: var(--var-theme-color);*/
        color: currentcolor;
        margin-bottom: 0;
    }

    header-stack-selector > select:hover {
        color: #0080e1;
    }

    :global(body.dark) header-stack-selector > select {
        background-color: transparent;
        color: var(--var-theme-base-color);
    }

    :global(body.dark) header-stack-selector > select:hover {
        color: #0080e1;
    }

    /* Commented out until needed
    logo-container {
        background-image: url("/Exciscope_logo_vektor_white.svg");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        width: 200px;
        display: inline-block;
        margin-top: 2px;
        flex-grow: 2;
        text-align: center;
    }
    */

    header-text {
        display: flex;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        font-size: 2em;
        font-weight: 100;
        margin: 0;
        flex-grow: 2;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    header-text.local {
        color: orange;
    }

    header-text.dev {
        color: darkred;
    }

    header-text.prod {
        color: black;
    }
    :global(body.dark) header-text.prod {
        color: white;
    }

    header-version {
        position: fixed;
        bottom: 0.5em;
        right: 0.5em;
        font-size: smaller;
        color: lightgray;
    }

    header-dark-toggle-button {
        /* position: fixed; */
        /* right: 0em; */
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 6px;
        padding-bottom: 2px;
        font-size: 1em;
        border-radius: 6px;
        margin: 2px 8px 2px 8px;
        /*display: inline;*/
        display: none;
        /*visibility: hidden;*/
        background-color: var(--var-theme-background-color);
        color: var(--var-theme-color);
        vertical-align: baseline;
        flex-grow: 0;
    }

    header-dark-toggle-button:hover {
        color: var(--var-theme-hover-background-color);
        cursor: pointer;
    }

    header-canvas-size-button {
        /* position: fixed; */
        /* right: 0em; */
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 6px;
        padding-bottom: 2px;
        font-size: 1em;
        border-radius: 6px;
        margin: 2px 8px 2px 8px;
        display: inline;
        /*visibility: hidden;*/
        background-color: var(--var-theme-background-base-color);
        color: var(--var-theme-base-color);
        vertical-align: baseline;
        flex-grow: 0;
    }
    header-downloader-toggle-button {
        /* position: fixed; */
        /* right: 0em; */
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 6px;
        padding-bottom: 2px;
        font-size: 1em;
        border-radius: 6px;
        margin: 2px 8px 2px 8px;
        display: inline;
        background-color: var(--var-theme-base-background-color);
        color: var(--var-theme-base-color);
        vertical-align: baseline;
        flex-grow: 0;
    }

    header-canvas-size-button:hover {
        color: var(--var-theme-hover-background-color);
        cursor: pointer;
    }

    header-downloader-toggle-button:hover {
        color: var(--var-theme-hover-background-color);
        cursor: pointer;
    }

    header-downloader-toggle-button.disabled {
        /*background-color: var(--var-theme-disabled-background-color);
        color: var(--var-theme-disabled-color);*/
        color: var(--var-theme-disabled-background-color);
        cursor: disabled;
    }

    header-downloader-toggle-button.disabled:hover {
        cursor: disabled;
    }

    header-debug-button {
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 6px;
        padding-bottom: 2px;
        font-size: 1em;
        border-radius: 6px;
        margin: 2px 8px 2px 8px;
        display: inline;
        background-color: var(--var-theme-base-background-color);
        color: var(--var-theme-base-color);
        vertical-align: baseline;
        flex-grow: 0;
    }

    header-debug-button:hover {
        color: var(--var-theme-hover-background-color);
        cursor: pointer;
    }

    header-debug-button.disabled {
        color: var(--var-theme-disabled-background-color);
        cursor: disabled;
    }

    header-debug-button.disabled:hover {
        color: var(--var-theme-hover-background-color);
        cursor: disabled;
    }

    header-user {
        font-size: 1em;
        text-transform: none;
        text-align: right;
        padding-left: 8px;
        padding-right: 8px;
        padding-top: 10px;
        flex-grow: 0;
        max-width: 10em;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    header-admin-button:hover,
    header-login-button:hover,
    header-logout-button:hover {
        background-color: var(--var-theme-hover-background-color);
        color: var(--var-theme-hover-color);
        cursor: pointer;
    }

    header-admin-button:hover {
        background-color: var(--var-theme-hover-background-color);
        color: var(--var-theme-hover-color);
        cursor: pointer;
        border-color: var(--var-theme-hover-background-color);
    }

    header-login-button,
    header-logout-button {
        color: var(--var-theme-color);
        background-color: var(--var-theme-background-color);
        outline: none;
        border-radius: 6px;
        margin: 2px 8px 2px 8px;
        padding: 8px 16px 8px 16px;
        flex-grow: 0;
    }

    header-admin-button {
        color: black;
        outline: none;
        border-radius: 6px;
        margin: 2px 8px 2px 8px;
        padding: 6px 16px 6px 16px;
        border: solid var(--var-theme-background-color) 2px;
    }

    header-pane {
        text-align: center;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: stretch;
        /*background-color: var(--var-theme-background-color);
        color:  var(--var-theme-color);*/
        background-color: var(--var-theme-base-background-color);
        color: var(--var-theme-base-color);
        border-bottom: 1px solid #333;
        padding-bottom: 2px;
    }
    :global(body.dark) header-pane {
        background-color: var(--var-theme-base-background-color);
        color: var(--var-theme-base-color);
        border-bottom: 1px solid white;
    }

    @media only screen and (max-width: 660px) {
        header-text {
            font-size: 1.5em;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        /*logo-container {
            visibility: hidden;
        }*/
    }
    @media only screen and (max-width: 580px) {
        header-text {
            font-size: 1em;
            max-height: 100%;
        }
        /*logo-container {
            visibility: hidden;
        }*/
    }

    @media only screen and (max-width: 450px) {
        header-text {
            visibility: hidden;
            font-size: 1em;
        }
        /*logo-container {
            visibility: hidden;
        }*/
    }

    @media only screen and (max-width: 450px) {
        header-text {
            visibility: hidden;
            font-size: 0.5em;
        }
        /*logo-container {
            visibility: hidden;
        }*/
    }
</style>
